module.exports = __webpack_public_path__ + "static/img/girl.5275e6c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/girl.svg
// module id = AEZQ
// module chunks = 1